var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 25,
    viewBox: "0 0 512 512",
    width: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 512C114.625 512 0 397.391 0 256 0 114.609 114.625 0 256 0c141.391 0 256 114.609 256 256 0 141.391-114.609 256-256 256zm0-448C149.969 64 64 149.969 64 256s85.969 192 192 192c106.047 0 192-85.969 192-192S362.047 64 256 64zm32 320h-64v-96h-96v-64h96v-96h64v96h96v64h-96v96z"
  })));
}
export default __webpack_public_path__ + "media/icons/icn_add-53fbbf45.svg";
export { SvgIcnAdd as ReactComponent };